import { render, staticRenderFns } from "./ResetPasswordComponent.vue?vue&type=template&id=9b34fd72"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports